
import { Link } from 'react-router-dom';

export default function ForumInLucru() {
  return (
    <main
      style={{
        minHeight: '65vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '40px 20px',
      }}
    >
      <h1 style={{ color: '#13b8ab', marginBottom: '16px' }}>
        🚧 Forumul este in lucru
      </h1>

      <p style={{ maxWidth: '520px', lineHeight: '1.7' }}>
        Pregatim un spatiu in care comunitatea ContaLearn
        va putea pune intrebari, discuta si invata impreuna.
        Revino in curand!
      </p>

      <Link
        to="/"
        style={{
          marginTop: '24px',
          padding: '12px 24px',
          background: '#13b8ab',
          color: '#ffffff',
          borderRadius: '10px',
          textDecoration: 'none',
          fontWeight: '600',
        }}
      >
        Inapoi la pagina principala
      </Link>
    </main>
  );
}
